import { useState, useContext, useEffect } from "react";
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FormContext } from "../context/FormContext";
import { ToolContext } from "../context/ToolContext";
import * as layout from "../constants/layout";
import { useSelector } from "react-redux";
import AssetIcon from "./assets/asset-icon/AssetIcon";

const IconDropDownMenu = ({ menuItems, selectedItem, activeCategory, selectItem, undo, redo }) => {
  const { formState } = useContext(FormContext);
  const { toolState, setToolState } = useContext(ToolContext);
  const { clientSettings } = formState;
  const { showResults, assessmentFailed } = toolState;
  const [dropdownOpen, setOpen] = useState([...menuItems.map(() => false)]);
  const [navbarHeight, setNavbarHeight] = useState(layout.NAVBAR_HEIGHT);

  const past = useSelector((state) => state.network.past);
  const future = useSelector((state) => state.network.future);
  const popupResults = useSelector((state) => state.settings.isPopupResultsEnabled);

  const handleWindowSizeChange = () => {
    const navbar = document.getElementById("ea_navbar");
    setNavbarHeight(navbar.clientHeight);
  };
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    // If the currently selected tool is disabled, revert to the first tool in the category
    menuItems.forEach((category, categoryIndex) => {
      const item = category.items[selectedItem[categoryIndex]];
      if (!toolIsEnabled(item.class)) {
        if (categoryIndex === activeCategory) {
          selectItem(categoryIndex, category.items[0], 0);
        } else {
          const _toolState = { ...toolState };
          _toolState.selectedTool[categoryIndex] = 0;
          setToolState(_toolState);
        }
      }
    });
  }, [showResults, assessmentFailed, activeCategory, JSON.stringify(selectedItem)]);

  const dropdownToggle = (categoryIndex) => {
    let _dropdownOpen = [...dropdownOpen];
    _dropdownOpen[categoryIndex] = !dropdownOpen[categoryIndex];
    setOpen(_dropdownOpen);
  };

  const toolIsEnabled = (toolClass) => {
    if (toolClass === "select-results") {
      return popupResults && showResults && !assessmentFailed;
    }
    return true;
  };

  return (
    <div className="mb-2" style={{ marginTop: navbarHeight - layout.NAVBAR_HEIGHT }}>
      <ButtonGroup vertical>
        {menuItems.map((category, categoryIndex) => (
          <ButtonDropdown
            key={categoryIndex}
            isOpen={dropdownOpen[categoryIndex]}
            toggle={() => dropdownToggle(categoryIndex)}
            direction="right"
          >
            <Button
              id={`icon${category.items[selectedItem[categoryIndex]].id}`}
              active={activeCategory === categoryIndex}
              color="dark"
              onClick={() => selectItem(categoryIndex)}
            >
              <AssetIcon assetStyle={category.items[selectedItem[categoryIndex]]} />
            </Button>
            <DropdownToggle
              split
              color="dark"
              id={`toggle${category.items[selectedItem[categoryIndex]].type}`}
            />
            <DropdownMenu color="dark">
              {category.items
                .filter((p) => !p.requiredFeature || clientSettings.features[p.requiredFeature])
                .map((item, itemIndex) => (
                  <DropdownItem
                    id={`item${item.id}`}
                    key={itemIndex}
                    tag="a"
                    disabled={!toolIsEnabled(item.class)}
                    onClick={() => selectItem(categoryIndex, item, itemIndex)}
                  >
                    <AssetIcon assetStyle={item} /> {item.name}
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </ButtonDropdown>
        ))}
        {clientSettings.features.HistoryModeEnabled && (
          <ButtonDropdown className="horizontal-buttons">
            <Button
              id="undo-button"
              color="dark"
              title="Undo"
              disabled={past.length === 0}
              onClick={undo}
            >
              <i className={"icon-undo-solid"}></i>
            </Button>
            <Button
              id="redo-button"
              color="dark"
              title="Redo"
              disabled={future.length === 0}
              onClick={redo}
            >
              <i className={"icon-redo-solid"}></i>
            </Button>
          </ButtonDropdown>
        )}
      </ButtonGroup>
    </div>
  );
};

export default IconDropDownMenu;
